import React from 'react'
import { Styles } from 'src/types/types'
import CartButton from '../CartDrawer/components/CartButton/CartButton'

const CartFooter = () => {
  return (
    <>
      <div style={styles.footer}>
        <CartButton />
      </div>
    </>
  )
}

const styles: Styles = {
  footer: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    width: '100vw',
    height: '7%',
    backgroundColor: '#fff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderTop: '1px solid lightgray',
  },
}

export default CartFooter
